import { render, staticRenderFns } from "./CompetitionCenterStudy.vue?vue&type=template&id=ae06e174&scoped=true&"
import script from "./CompetitionCenterStudy.vue?vue&type=script&lang=js&"
export * from "./CompetitionCenterStudy.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionCenterStudy.vue?vue&type=style&index=0&id=ae06e174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae06e174",
  null
  
)

export default component.exports